<template>
  <v-container fluid>
    <v-toolbar>
      <v-toolbar-title>{{ $t('PLANNINGS.TITLE') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn dark color="indigo" @click="$router.go(-1)">
        {{ $t('BUTTON.BACK') }}
      </v-btn>
    </v-toolbar>

    <v-row class="my-4">
      <v-col cols="12" xl="9" lg="8" md="7">
        <v-card color="#f2f8ff">
          <v-card-text>
            <schedule-filters />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" xl="3" lg="4" md="5">
        <v-autocomplete
          :value="order"
          :items="ordersList"
          :label="$t('ORDERS.ITEM')"
          item-text="order"
          item-value="id"
          dense
          chips
          small-chips
          single-line
          append-outer-icon="mdi-close"
          @change="saveOrder"
          @click:append-outer="saveOrder(null)"
        ></v-autocomplete>
        <order-sheet
          v-if="currentOrder"
          class="pa-4 overflow-y-auto"
          :order="currentOrder"
          rounded
          small
          max-height="400"
        ></order-sheet>
      </v-col>
    </v-row>

    <v-sheet tile>
      <v-row>
        <v-col cols="12" xl="4" md="6" xs="12">
          <v-menu
            ref="day"
            min-width="290px"
            transition="scale-transition"
            :close-on-content-click="false"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                autocomplete="nope"
                prepend-inner-icon="mdi-calendar"
                :value="day | dateFormat"
                :label="$t('PLANNINGS.DESIRED_DATE')"
                clearable
                v-bind="attrs"
                v-on="on"
                @click:clear="saveDay()"
              ></v-text-field>
            </template>
            <v-date-picker
              :value="day"
              first-day-of-week="1"
              show-week
              @change="saveDay"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="d-flex" cols="12" xl="4" md="6" xs="12">
          <v-btn
            text
            color="secondary"
            class="ma-4"
            @click="$refs.schedule.prev()"
          >
            {{ $t('PLANNINGS.CALENDAR_PREVIOUS_WEEK') }}
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="secondary"
            class="ma-4"
            @click="$refs.schedule.next()"
          >
            <v-icon>mdi-chevron-right</v-icon>
            {{ $t('PLANNINGS.CALENDAR_NEXT_WEEK') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-sheet>

    <v-row class="fill-height">
      <v-col xs="12" md="9">
        <v-sheet tile>
          <schedule ref="schedule" @event-dropped="onEventDropped"></schedule>
        </v-sheet>
      </v-col>
      <v-col xs="12" md="3">
        <tasks ref="tasks"></tasks>
      </v-col>
    </v-row>
    <snacks></snacks>
  </v-container>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters, mapState } from 'vuex';
import { mapCacheActions } from 'vuex-cache';
import { dateFormat } from '@/modules/_global/filters';
import query from '@/modules/_global/mixins/query';
import Tasks from '../components/Tasks';
import Snacks from '../components/Snacks';
import OrderSheet from '../components/OrderSheet';
import Schedule, { DATE_FORMAT } from '../components/Schedule';
import ScheduleFilters from '../components/ScheduleFilters';
import { isEmpty } from 'lodash';

export default {
  name: 'PlanningPage',

  filters: {
    dateFormat
  },

  components: {
    Tasks,
    Snacks,
    Schedule,
    OrderSheet,
    ScheduleFilters
  },

  mixins: [query],

  data() {
    return {
      currentOrder: null
    };
  },

  computed: {
    ...mapState('planning', ['day', 'ordersList', 'order']),
    ...mapGetters('planning', ['SELECTED_ORDER'])
  },

  watch: {
    day: 'saveDay',
    SELECTED_ORDER: {
      deep: true,
      immediate: true,
      handler: 'getSelectedOrder'
    }
  },

  mounted() {
    this.init();
    this.getOrdersList();
  },

  methods: {
    ...mapActions('planning', ['setDay', 'setOrder', 'setScheduleFilters']),
    ...mapCacheActions('planning', ['getOrdersList']),
    ...mapCacheActions('order', ['getOrder']),
    init() {
      this.setDay(moment(this.getQueryParam('day')).format(DATE_FORMAT));
      this.setOrder(this.getQueryParam('order', null, parseInt));
    },
    saveDay(day) {
      this.setDay(day);
      this.setQueryWithoutError({ day });
      this.$refs.day.save(day);
    },
    saveOrder(order) {
      this.setOrder(order);
      this.setQueryWithoutError({ order });
    },
    setQueryWithoutError(query) {
      this.setQuery(query).catch(() => {});
    },
    getSelectedOrder() {
      if (!this.SELECTED_ORDER) {
        return;
      }

      this.getOrder({ orderId: this.SELECTED_ORDER.id }).then(({ data }) => {
        this.currentOrder = data;
      });
    },
    onEventDropped({ event, day, entity }) {
      this.$refs.tasks.copyTask({ event, day, entity });
    }
  }
};
</script>
